import React from "react";
import BecomeAVendorAccordion from "./BecomeAVendorAccordion";
import AIAboutGenerator from "./AIAboutGenerator";

export default function VendorPageWrapper() {
  // Retrieve values from localStorage
  const category = localStorage.getItem("vendor_category");
  const location = localStorage.getItem("vendor_state");

  return (
    <div className="relative">
      <BecomeAVendorAccordion />

      {/* Floating AI Button */}
      {category && location && (
        <div className="fixed bottom-6 right-6 z-50">
          <AIAboutGenerator category={category} location={location} />
        </div>
      )}
    </div>
  );
}